var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{directives:[{name:"t",rawName:"v-t",value:(`${_vm.type}.status.${_vm.value}`),expression:"`${type}.status.${value}`"}],class:[
      'badge text-uppercase text-condensed smaller py-2 px-2.5',
      [_vm.$options.status.FINISHED, _vm.$options.status.DISQUALIFIED, _vm.$options.status.CANCELLED].includes(_vm.value)
        ? 'badge-gray'
        : 'badge-secondary'
    ]})])
}
var staticRenderFns = []

export { render, staticRenderFns }